import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
export const useRole = () => {
    const roleStore = useSelector((state: any) => state.auth.user.role)

    const isRole = (role: string) => {
        return role
    }

    return { role: roleStore, isRole }
}

export const ManageContainerClass = ()=> {
    const [width, setDimensions] = useState(window.innerWidth)

  useEffect(() => {
    function handleResize() {
      setDimensions(window.innerWidth)
    }

    window.addEventListener('resize', handleResize)
    return ()=> window.removeEventListener('resize',handleResize)
  },[])
  return [width]
}
